import cls from "./BlogQuote.module.css";

interface BlogQuoteProps {
    html: string;
}

export const BlogQuote = ({ html }: BlogQuoteProps) => {
    return <blockquote className={cls.quote} dangerouslySetInnerHTML={{ __html: html }} />;
};
